import { useToast } from "@/components/ui/use-toast";
import {
  AdminExpenseReportFilterInput,
  useProcessExpenseReportDownloadAndGetUrlMutation,
} from "@common/utils/graphql";
import { Spinner } from "@hypercard/web-components";
import { ReactNode } from "react";

type Props = {
  filters: AdminExpenseReportFilterInput | null;
  children?: ReactNode;
};

export const DownloadCSVButton = ({ filters, children }: Props) => {
  const [processExpenseReportDownloadAndGetUrl, { loading }] =
    useProcessExpenseReportDownloadAndGetUrlMutation();
  const { toast } = useToast();

  const handleDownloadCSV = async () => {
    const { data } = await processExpenseReportDownloadAndGetUrl({
      variables: {
        filters,
      },
    });
    if (
      data?.processExpenseReportDownloadAndGetUrl.__typename ===
      "MutationProcessExpenseReportDownloadAndGetUrlSuccess"
    ) {
      const url = data.processExpenseReportDownloadAndGetUrl.data;
      // TODO: @rushil this is flaky
      setTimeout(() => {
        window.open(url, "_blank");
      }, 1000);
    } else {
      toast({
        title: "Error downloading CSV",
        description:
          "There was an error downloading the CSV. Please try again later.",
        variant: "destructive",
      });
    }
  };

  return loading ? (
    <Spinner colorVariant="light" className="size-4" />
  ) : (
    <button onClick={handleDownloadCSV} disabled={loading}>
      {children}
    </button>
  );
};
